export default __webpack_public_path__ + "static/media/katana-logo-purple.43395c29.svg";